<template>
  <div id="stackedEchart"></div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "stackedLineChart",
  props: {
    echartsData: {
      type: Array,
      default: {
        return: [],
      },
    },
  },
  data() {
    return {
      myChart: {},
    };
  },
  created() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  mounted() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.resize();
    // };
  },
  watch: {
    echartsData: function (newVal) {
      this.loadEchart();
    },
  },
  methods: {
    loadEchart() {
      let colors = ["#F03037", "#FFBE98", "#4868AF"];
      this.myChart = Echarts.init(document.getElementById("stackedEchart"));
      let option = {
        title: {
          // text: "折线图堆叠",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          bottom: "bottom",
          textStyle: {
            color: "#B4BBE0",
          },
          data: ["已巡查任务数", "未巡查任务数", "参与人次"],
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "5%",
          bottom: "15%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "category",
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            // interval:0,
            // rotate:30,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "14",
            },
          },
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5,
              fontSize: 14,
            },
          },
          data: [],
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 14,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "14",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1,
            },
          },
        },
        series: [
          {
            name: "已巡查任务数",
            type: "line",
            stack: "总量",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6,
            },
          },
          {
            name: "未巡查任务数",
            type: "line",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6,
            },
          },
          {
            name: "参与人次",
            type: "line",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6,
            },
          },
        ],
        color: colors,
      };
      option.series[0].data = this.echartsData.map((item) => {
        // console.log(item);
        return {
          // name:item.name || '',
          value: item.patroled || 0,
        };
      });
      option.series[1].data = this.echartsData.map((item) => {
        return {
          // name:item.name || '',
          value: item.noPatrol || item.value || 0,
        };
      });
      option.series[2].data = this.echartsData.map((item) => {
        return {
          // name:item.name || '',
          value: item.persons || 0,
        };
      });
      option.xAxis.data = this.echartsData.map((item) => {
        return item.ym || "";
      });
      // console.log(option.xAxis.data)
      // console.log(option.legend.data)

      this.myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
#stackedEchart {
  // width: 1000px;
  height: 210px;
  width: 440px;
}
</style>
